import { API } from 'aws-amplify'

export default {
  createBid(data) {
    const query = `mutation createBid(
                $organizationId: String!,
                $bid: BidInput!
            ) {
            createBid(
                organizationId: $organizationId
                bid: $bid
            ) {
                value {
                    amount
                    currency
                }
                mpID
            }
        }`
    const variables = {
      organizationId: data.organizationId,
      bid: data.bid,
    }
    return API.graphql({
      query,
      variables,
    })
  },
  publishBid(mpID) {
    const query = `mutation publishBid(
            $mpID: String!
        ) {
            publishBid(
            mpID: $mpID
        ) {
            mpID
        }
    }`

    return API.graphql({
      query,
      variables: {
        mpID,
      },
    })
  },
  cancelBid(mpID) {
    const query = `mutation deleteBid(
            $mpID: String!
        ) {
            deleteBid(
            mpID: $mpID
        ) {
            mpID
        }
    }`

    return API.graphql({
      query,
      variables: {
        mpID,
      },
    })
  },
  deleteBid(mpID) {
    const query = `mutation deleteBid(
            $mpID: String!
        ) {
            deleteBid(
            mpID: $mpID
        ) {
            mpID
        }
    }`

    return API.graphql({
      query,
      variables: {
        mpID,
      },
    })
  },
  updateBid(data) {
    const query = `mutation updateBid(
            $mpID: String!,
            $value: ValueInput
        ) {
            updateBid(
            mpID: $mpID,
            value: $value
        ) {
            mpID
        }
    }`

    return API.graphql({
      query,
      variables: {
        mpID: data.mpID,
        value:
          (data.bid.value && {
            amount: data.bid.value.amount,
            currency: data.bid.value.currency,
          }) ||
          null,
      },
    })
  },
}
